import { CAR_TYPE_OPTIONS } from '@/modules/Search/components/CarResults/CarResultsFilter/CarResultsFilter.constants'
import { CarType } from '@/modules/Search/types'

export const CAR_TYPE_LIST: { key: string; value: CarType }[] =
  CAR_TYPE_OPTIONS.map((option, index) => ({
    key: option,
    value: Object.values(CarType)[index] as CarType,
  }))
